<script setup lang="ts">
  import {
    breadCrumbContainerClass,
    breadcrumbBackLinkClass,
  } from './BreadCrumb.css';
  import BreadCrumbItem from './BreadCrumbItem/BreadCrumbItem.vue';
  import { useBreadcrumbStore } from '../../store/breadcrumb.store';
  import { computed } from 'vue';
  import { useRouter } from 'vue-router';
  import { Link, LinkVariant } from '@tundr/ds-components';
  import { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';
  import { useLocale } from '@tundr/i18n';

  const breadcrumbStore = useBreadcrumbStore();
  const router = useRouter();
  const { t } = useLocale();

  const items = computed(() => {
    return breadcrumbStore.items;
  });

  const handleBack = () => {
    router.back();
  };
</script>

<template>
  <div :class="breadCrumbContainerClass" v-if="items?.length">
    <Link
      v-if="!breadcrumbStore.hideBackButton"
      :variant="LinkVariant.Secondary"
      :icon-left="TUNDR_ICONS.ARROW_LEFT"
      :class="breadcrumbBackLinkClass"
      test-id="breadcrumb-back-link"
      @click="handleBack"
    >
      {{ t('common:actions.breadcrumb_back') }}
    </Link>
    <BreadCrumbItem
      v-for="(item, index) in items"
      :key="item.title"
      v-bind="item"
      :is-last="items.length - 1 === index"
    />
  </div>
</template>
